import axios from "axios";

export default {
    async DriverLicenseReport(data) {
        const response = await axios.post("/api/hroperations/driverlicensereport", data);
        return response;
    },
    async DriverLicenseDashboard() {
        const response = await axios.get("/api/hroperations/employee/driverlicense/dashboard");
        return response;
    },
};
